import React from 'react'
import { FormattedMessage, injectIntl } from 'react-intl'


const Aziende = ({ intl: { locale } }) => (
  <>
    {locale === 'it' && (
      <section id="comments" className="section text-center section text-center aziende clearfix" aria-labelledby="comments">
        <div className="container">
          <div className="row">
            <div className="col-sm-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2">
              <div data-aos="fade-up" className="aos-init aos-animate">
                <h1 id="region-aziende" className="section__title">
                  Alcuni commenti dei partecipanti:
                </h1>
                <div className="section__extra-body">
                  <p>“Interessante e <strong>utilissimo</strong>”</p>
                  <p>“Ottima occasione per comprendere come e dove stiamo andando, formarsi e fare <strong>benchmark</strong>”</p>
                  <p>“Molti spunti di riflessione, <strong>workshop</strong> molto utili”</p>
                  <p>“Per <strong>fare networking</strong> e soprattutto per trarre ispirazione o imparare da progetti e idee sviluppate da altre aziende”</p>
                  <p>“Molto <strong>concreto</strong> e affronta le tematiche che più interessano chi lavora nella comunicazione interna”</p>
                  <p>“Offre la possibilità concreta di confrontarsi con persone che si occupano di intranet sia dal punto di vista HR sia IT sia Comunicazione. Una vera <strong>occasione di crescita</strong>”</p>
                  <p>“Per il networking e le <strong>nuove idee</strong> che vengono fuori”</p>
                  <p>“<strong>Unico</strong> nel suo genere”</p>
                  <p>“Sono stati affrontati temi di <strong>assoluta attualità</strong> con casi pratici e molto interessanti”</p>
                  <p>“Altissima <strong>qualità dei contenuti</strong>”</p>
                  <p>“Un buon modo per conoscere le <strong>best practices</strong> e creare networking”</p>
                  <p>“Ottima organizzazione e <strong>contenuti</strong> molto interessanti”</p>
                  <p>“In Italia ci voleva un confronto tra chi vive la gestione della intranet tutti i giorni, e anche con gli <strong>specialisti del settore</strong> che possono far emergere idee, domande e ricerca di nuove soluzioni.”</p>
                  <p>“Evento <strong>specializzato</strong> in un settore di cui si parla poco”</p>
                  <p>“Nel settore è <strong>l'eccellenza italiana</strong>”</p>
                  <p>“Ottima occasione per confrontarsi e <strong>conoscere practitioners</strong> sulle intranet, di altre aziende”</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    )}
    <section id="aziende" className="section text-center section text-center aziende clearfix" aria-labelledby="aziende">
      <div className="container">
        <div className="row">
          <div className="col-sm-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2">
            <div data-aos="fade-up" className="aos-init aos-animate">
              <h1 id="region-aziende" className="section__title">
                <FormattedMessage id="aziende-title" />
              </h1>
              <div>
                <p className="section__body-list">
                  <FormattedMessage id="aziende-2019" />
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </>
);

export default injectIntl(Aziende);